<template>
  <div>
    <!-- 购入车 -->
    <div class="purchasedCar comBox" style="margin-top: 0.7rem">
      <div style="color: #333333; font-size: 0.2rem; margin-bottom: 0.2rem">
        购物车
      </div>

      <div style="width: 100%; margin-bottom: 0.16rem">
        <el-table
          ref="multipleTableRef"
          :data="data"
          @selection-change="handleSelectionChange"
          style="width: 100%"
          height="550"
        >
          <el-table-column type="selection" width="55" :selectable="callback" />
          <el-table-column property="name" min-width="100" label="全部素材">
            <template #default="scope">
              <div style="display: flex">
                <div style="" class="table_img">
                  <!-- materialStatus -->
                  <div
                    class="materialStatus"
                    v-if="scope.row.materialStatus != 1"
                  >
                    失效商品
                  </div>
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.showImage"
                  />
                </div>
                <div class="table_information">
                  <div
                    style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      color: #333333;
                      font-size: 0.14rem;
                    "
                  >
                    {{ scope.row.title }}
                  </div>
                  <div
                    v-if="scope.row.authType == 'SELF'"
                    style="color: #86909c; font-size: 0.12rem"
                    class="typeName"
                  >
                    个人授权
                  </div>
                  <div
                    v-if="scope.row.authType == 'ENTERPRISE'"
                    style="color: #86909c; font-size: 0.12rem"
                    class="typeName"
                  >
                    企业授权
                  </div>
                  <div
                    v-if="scope.row.authType == 'UNION'"
                    style="color: #86909c; font-size: 0.12rem"
                    class="typeName"
                  >
                    联盟授权
                  </div>
                  <div style="font-size: 0.14rem">
                    <span style="color: #86909c">单价：</span
                    >{{ scope.row.selfPrice }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            property="newPayCount"
            width="200"
          />
          <el-table-column
            label="价格"
            align="center"
            property="price"
            width="200"
          >
            <template #default="scope">
              <div style="color: #C01A26">
                <span>￥</span
                >{{ (scope.row.selfPrice * scope.row.newPayCount).toFixed(2) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="190" align="center">
            <template #default="scope">
              <div
                style="color: #ff2929; cursor: pointer"
                @click="handleDel(scope.$index, scope.row, 'del')"
              >
                删除
              </div>
            </template>
          </el-table-column>

          <template #empty>
            <div style="height: 550px" v-if="data.length == 0">
              <div style="width: 90%; margin: 0 auto">
                <img
                  style="width: 100%; margin: 0 auto"
                  src="../../assets/zt_404.png"
                />
              </div>
            </div>
          </template>
        </el-table>

        <div class="table_bottom">
          <div style="display: flex; justify-content: space-between">
            <div
              style="font-size: 0.14rem; color: #333333; margin-left: 0.13rem"
            >
              <span
                @click="selectAll"
                v-if="!allCheckbox"
                class="el-checkbox__inner_zd"
              ></span>
              <span
                @click="selectAll"
                v-if="allCheckbox"
                class="el-checkbox__inner_select"
              ></span>
              <span style="margin-top: -10px; margin-left: 5px; color: #666"
                >全选</span
              >
            </div>
            <div
              style="
                color: #86909c;
                margin-left: 0.32rem;
                font-size: 0.14rem;
                cursor: pointer;
              "
              @click="handleAllDel('delAll')"
            >
              删除选中商品
            </div>
            <div
              style="
                color: #86909c;
                margin-left: 0.32rem;
                font-size: 0.14rem;
                cursor: pointer;
              "
              @click="handleAllExpire('expire')"
            >
              清除失效商品
            </div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div class="yixuan">
              已选商品<span style="color: #C01A26">{{
                multipleSelection.length
              }}</span
              >件
            </div>
            <div class="heji">
              合计：
              <span style="color: #C01A26">￥{{ (totalPay / 1).toFixed(2) }}</span>
            </div>
            <div class="btn" @click="paymentClick">结算</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 删除 -->
    <el-dialog title="" v-model="dialogDelVisible" align-center width="480px" :close-on-click-modal="false">
      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img
          style="100%;height: 100%;"
          src="@/assets/img/tips／exclamation-circle-fill@2x.png"
        />
      </div>

      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        {{ title }}
        <!-- {{'确认清除所有失效商品?'}} -->
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="dialogDelVisible = false">取消</div>
        <div class="dataBtnSubmit" @click="delSubmit">确认</div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import type { TabsPaneContext } from "element-plus";
import { ElMessage, ElTable } from "element-plus";
import { Axios } from "../../assets/js/ls_com_axios.js";
document.title = "标识山西-购物车";
const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};
// 表格

interface User {
  date: string;
  name: string;
  name1: string;
  address: string;
  katype: string;
  price: string;
  number: number;
  time: string;
}
const totalPay = ref(0.0);

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
  console.log(multipleTableRef.value);
  totalAmount();
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
  totalAmount();
  console.log(multipleSelection);
};
var data = ref([]); // 创建一个空数组
//全选
const allCheckbox = ref(false);
const selectAll = () => {
  allCheckbox.value = !allCheckbox.value;
  console.log(allCheckbox.value);
  if (allCheckbox.value) {
    data.value.forEach((item, index) => {
      console.log(multipleTableRef.value);
      multipleTableRef.value!.toggleRowSelection(item, true);
    });
    totalAmount();
  } else {
    data.value.forEach((item, index) => {
      console.log(multipleTableRef.value);
      multipleTableRef.value!.toggleRowSelection(item, false);
    });

    totalAmount();
  }
};
const totalAmount = () => {
  let sum = 0;
  multipleSelection.value.forEach((item) => {
    sum += item.newPayCount * item.selfPrice;
  });

  totalPay.value = sum.toFixed(2);
};
// 删除、批量删除
let title = ref("");
let dialogDelVisible = ref(false);
let delArry = ref([]); //删除id
const handleDel = (index, row) => {
  title.value = "确定删除此商品？";
  dialogDelVisible.value = true;
  delArry.value = [];
  delArry.value = [row.id];
};
const handleAllDel = (type) => {
  if (multipleSelection.value.length == 0) {
    ElMessage({
      message: "请勾选商品",
      type: "error",
    });
    return;
  }
  title.value = "确定批量删除勾选的商品？";
  dialogDelVisible.value = true;
  delArry.value = [];

  multipleSelection.value.forEach((item) => {
    delArry.value.push(item.id);
  });
};
//购物车失效商品清除
const handleAllExpire = (type) => {
  title.value = "确定清除全部失效商品？";

  delArry.value = [];
  data.value.forEach((item, index) => {
    if (item.materialStatus != 1) {
      delArry.value.push(item.id);
    }
  });

  if (delArry.value.length == 0) {
    ElMessage({
      message: "暂无失效商品",
      type: "error",
    });
    return;
  }

  dialogDelVisible.value = true;
};

//确认删除
const delSubmit = () => {
  Axios("delete", `/fodder/car/${delArry.value}`, {}, false, (res) => {
    if (res.data.code == 200) {
      dialogDelVisible.value = false;
      get_dindanList();

      ElMessage({
        message: "删除成功",
        type: "success",
      });
    } else {
      ElMessage({
        message: "删除错误",
        type: "error",
      });
    }
  });
};

/**表格回调函数*/
const callback = (row, index) => {
  return row.materialStatus == 1 ? 1 : 0;
};

//购物车列表展示
const get_dindanList = function () {
  Axios(
    "get",
    "/fodder/car/list",
    {
      memberId: JSON.parse(localStorage.getItem("userList")).memberId,
      orderByColumn: "a.create_time",
      isAsc: "DESC",
    },
    false,
    function (res) {
      res.data.rows.forEach((item, index) => {
        item.newPayCount = 1;
      });
      data.value = res.data.rows;
    }
  );
};
get_dindanList();

//结算
import { useRouter } from "vue-router";
const router = useRouter();
const paymentClick = () => {
  // totalPay.value  勾选的总金额
  // multipleSelection.value   勾选购物车的商品
  if (multipleSelection.value.length == 0) {
    ElMessage({
      message: "请选择商品",
      type: "warning",
    });
    return;
  }
  let idArray = [];
  let isStop = false;
  multipleSelection.value.forEach((item, index) => {
    idArray.push(item.id);
    if(item.selfPrice == 0){
      isStop = true
    }
  });
  if (isStop) {
    ElMessage({
      message: "免费商品不可加入购物车,请删除",
      type: "warning",
    });
    return;
  }
  let query = idArray.join(",");

  Axios("get", "/fodder/car/index/" + query, false, false, function (res) {
    router.push({
      path: "/myOrderDetial",
      query: {
        type: "car",
        arry: query,
      },
    });
    // window.close();
  });
};
</script>

<style scoped lang="less">
@import url(/src/assets/css/com.css);

.purchasedCar {
  margin: 0 auto;
  background: #fff;
}

.table_img {
  background-color: #3fa4ed;
  width: 1.58rem;
  height: 0.94rem;
  background: #d9d9d9;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  margin-right: 0.1rem;
  position: relative;
}

.table_information {
  width: calc(100% - 1.58rem - 0.1rem);
  height: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.typeName {
  white-space: nowrap;
  /* 文本不换行 */
  overflow: hidden;
  /* 溢出部分隐藏 */
  text-overflow: ellipsis;
  /* 使用省略号表示溢出部分 */
}

.table_bottom {
  width: 100%;
  background: #f2f3f5;
  height: 0.46rem;
  line-height: 0.46rem;
  display: flex;
  justify-content: space-between;

  .yixuan {
    margin-right: 0.54rem;
    font-size: 0.14rem;
  }

  .heji {
    margin-right: 0.54rem;
    font-size: 0.14rem;
  }

  .btn {
    width: 2.03rem;
    height: 0.46rem;
    line-height: 0.46rem;
    background: #C01A26;
    border-radius: 0rem 0rem 0rem 0rem;
    opacity: 1;
    text-align: center;
    color: #fff;
    font-size: 0.14rem;
    cursor: pointer;
  }
}

.materialStatus {
  width: 0.9rem;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 0.04rem;
  padding: 0 0.2rem;
  box-sizing: border-box;
  color: #ffffff80;
  border-radius: 0.2rem;
  margin: auto;
}

/deep/.el-dialog.is-align-center {
  border-radius: 20px !important;
}

/deep/.el-table thead th {
  background: #e3e6ec !important;
}

/* 全选自定义 */
.el-checkbox__inner_zd {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
  /* width: var(--el-checkbox-input-width);
			height: var(--el-checkbox-input-height); */
  background-color: #fff;
  z-index: var(--el-index-normal);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    outline 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}

.el-checkbox__inner_select::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid transparent;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  transition: transform 0.15s ease-in 50ms;
  transform-origin: center;
  transform: rotate(45deg) scaleY(1);
  border-color: var(--el-checkbox-checked-icon-color);
}

.el-checkbox__inner_select {
  width: 14px;
  height: 14px;
  display: inline-block;
  position: relative;
  border: 1px solid #C01A26;
  border-radius: 2px;
  box-sizing: border-box;
  color: #fff;
  background-color: #C01A26;
  z-index: var(--el-index-normal);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    outline 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
</style>
